export default "__VITE_ASSET__zF51ySGp__"